import { cn } from "@/lib/cn";

interface SkeletonProps {
    className?: string;
}

export function Skeleton({ className }: SkeletonProps) {
    return (
        <div className={cn("rounded bg-gray-100 animate-pulse", className)} />
    );
}
